<template>
  <div class="w-full md:w-auto">
    <div v-if="services" class="flex md:hidden items-center gap-ds-sm justify-start w-full">
      <img
        :src="`/content-static/navigation-menu/login.svg`"
        alt="Login"
        class="fixed-size"
        loading="lazy"
      />
      <a
        v-if="username"
        :href="`${this.v4Host}/dashboard`"
        class="no-underline text-black70 hover:no-underline hover:text-black70"
      >
        {{ $t("navigation.login.dashboard") }}
      </a>
      <a
        v-else-if="redirectUrl"
        :href="redirectUrl"
        class="text-gray-700 whitespace-nowrap no-underline focus:no-underline"
      >
        {{ $t("navigation.login.login") }}
      </a>
      <span v-else @click="$emit('click')">{{ $t("navigation.login.login") }}</span>
    </div>

    <div
      v-if="header"
      class="hidden md:flex relative items-center w-auto cursor-pointer text-white ml-ds-md"
      @click="toggleDropdown(true)"
    >
      <Icon
        class="mr-ds-sm"
        :size="22"
        name="i:user" />
      <div class="overflow-hidden hidden lg:block">
        <div v-if="username" class="font-bold whitespace-nowrap text-white">
          {{ $t("navigation.login.my_anyvan") }}
        </div>
        <a
          v-else-if="redirectUrl"
          :href="redirectUrl"
          class="font-bold whitespace-nowrap text-white no-underline hover:no-underline hover:text-white focus:no-underline focus:text-white"
        >
          {{ $t("navigation.login.login") }}
        </a>
        <span v-else class="font-bold whitespace-nowrap" @click="showLogin">{{
          $t("navigation.login.login")
        }}</span>
      </div>

      <div
        v-show="showDropdown"
        class="absolute top-full flex flex-col right-0 mt-ds-xxs bg-white rounded-lg shadow-rebrand min-w-[150px] overflow-hidden"
        @mouseleave="toggleDropdown(false)"
      >
        <a
          v-if="username"
          class="px-ds-ml py-ds-md hover:bg-gray-100 cursor-pointer text-gray-700 no-underline text-black hover:no-underline hover:text-black focus:no-underline focus:text-black"
          :href="`${this.v4Host}/dashboard`"
        >
          {{ $t("navigation.login.dashboard") }}
        </a>
        <a
          v-if="username"
          class="px-ds-ml py-ds-md hover:bg-gray-100 cursor-pointer text-gray-700 border-t border-t-black10 no-underline text-black hover:no-underline hover:text-black focus:no-underline focus:text-black"
          :href="`${this.v4Host}/logout`"
        >
          {{ $t("navigation.login.logout") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_USER } from "~/store/auth"

export default defineComponent({
  name: "NavLoginButton",
  props: {
    services: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: false
    },
    redirectUrl: {
      type: String,
      default: ""
    },
    hostname: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showDropdown: false,
      v4Host: this.hostname ?? (this.$config.public.v4Host as string)
    }
  },
  computed: {
    ...mapGetters("auth", {
      user: GET_USER
    }),
    username(): string {
      if (!this.user) {
        return ""
      }
      return this.user?.username || ""
    }
  },
  methods: {
    showLogin() {
      this.$emit("show-login-form")
    },
    toggleDropdown(show: boolean) {
      if (this.username) {
        this.showDropdown = show
      } else {
        this.showLogin()
      }
    }
  }
})
</script>
